// extracted by mini-css-extract-plugin
module.exports = {"tips":"tips___ZwOKM","tipsmsg":"tipsmsg___2QMct"};